export default "__VITE_ASSET__db0bd847__"